import React from 'react'
import lang from 'lang'
import CommonLayout from 'components/common-layout'
import Head from 'components/head'
import Modal from 'common/components/modal'
import ExternalHtml from 'services/html-content/external-html'

export default class Privacy extends React.Component {
  render() {
    return (
      <CommonLayout>
        <Head title={lang.privacy} />
        <Modal />
        <style jsx>
          {`
            .hero-section {
              margin-bottom: 3rem;
            }
          `}
        </style>
        <div className="hero-section">
          <div className="grid-container">
            <p>
              <strong>{lang.aboutWebsites}</strong>
            </p>
            <ExternalHtml slug="privacy" />
          </div>
        </div>
      </CommonLayout>
    )
  }
}
